export function getFormLink(userId: string): string {
  return `${import.meta.env.VITE_FORM_LINK}/${userId}`;
}
